<template>
  <v-container
    fluid>
    <v-row>
      <v-col
        cols="12"
        v-for="favourite in filteredFavourites"
        :key="favourite.id">
        <notice-card
          v-if="favourite.id !== 'removed'"
          :notice-obj="favourite"
        />
        <notice-card
          v-else
          :message="'This item was removed by teacher.'"
          :id="favourite.item_id"
          :fav="favourite.fav"
          :type="favourite.type"
        />
      </v-col>
      <v-col v-if="filteredFavourites.length === 0">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition">
          You do not have any favourite items yet.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NoticeCard from '../components/NoticeCard'

export default {
  components: {
    NoticeCard
  },

  data: () => ({
    favourites: []
  }),
  computed: {
    filteredFavourites: function () {
      return this.favourites.filter(favourite => typeof favourite.id !== 'undefined')
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      vm.$http.get('caregiversV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.userId + '/pupilsV2/' + vm.$store.state.pupilId + '/favouritesV2')
        .then(resp => {
          vm.favourites = resp.data
          vm.$store.commit('loading', false)
        })
    })
  }
}
</script>
